<ng-container *ngTemplateOutlet="itemTemplate; context: getFinalContext()"></ng-container>
